import ApiService from '../../services/api.service'
import { Notify } from 'quasar'

export const schedulerDayOffs = {
  namespaced: true,
  state: {
    dayOffs: [],
    loadedYears: [] // Garde la trace des années déjà chargées
  },
  mutations: {
    SET_DAY_OFFS(state, dayOffs) {
      state.dayOffs = dayOffs
    },
    ADD_DAY_OFFS(state, { year, dayOffs }) {
      // Ajouter les jours fériés sans écraser les années précédentes
      const newDayOffs = dayOffs.filter(newDayOff => {
        // Éviter les doublons
        return !state.dayOffs.some(existingDayOff =>
          existingDayOff.date === newDayOff.date
        )
      })
      state.dayOffs = [...state.dayOffs, ...newDayOffs]

      // Marquer l'année comme chargée
      if (!state.loadedYears.includes(year)) {
        state.loadedYears.push(year)
      }
    },
    CLEAR_DAY_OFFS(state) {
      state.dayOffs = []
      state.loadedYears = []
    }
  },
  getters: {
    dayOffs: state => state.dayOffs,
    dayOffDates: state => state.dayOffs.map(d => d.date),
    isYearLoaded: state => year => state.loadedYears.includes(year)
  },
  actions: {
    async fetchDayOffs({ commit, getters }, year) {
      try {
        // Vérifier si l'année est déjà chargée
        if (getters.isYearLoaded(year)) {
          return getters.dayOffs.filter(d => {
            const dayOffYear = new Date(d.date).getFullYear()
            return dayOffYear === year
          })
        }

        //console.log(`Chargement des jours fériés pour ${year}...`)
        const response = await ApiService.getRequest('/scheduler_day_offs', { year })
        const dayOffs = response.data['hydra:member'] || response.data
        commit('ADD_DAY_OFFS', { year, dayOffs })
        return dayOffs
      } catch (error) {
        console.error(`Erreur lors de la récupération des jours fériés ${year}:`, error)
        Notify.create({
          message: `Impossible de charger les jours fériés ${year}`,
          color: 'red'
        })
        throw error
      }
    },
    async fetchDayOffsForYears({ dispatch }, years) {
      try {
        // Charger plusieurs années en parallèle
        const promises = years.map(year => dispatch('fetchDayOffs', year))
        await Promise.all(promises)
      } catch (error) {
        console.error('Erreur lors du chargement multi-années:', error)
      }
    }
  }
}
